// @Flow
import { ADD_LOADING, REMOVE_LOADING } from './constants';

var addLoading = function addLoading(currentAction) {
  return {
    type: ADD_LOADING,
    payload: {
      currentAction: currentAction
    }
  };
};

var removeLoading = function removeLoading(currentAction) {
  return {
    type: REMOVE_LOADING,
    payload: {
      currentAction: currentAction
    }
  };
};

export default {
  addLoading: addLoading,
  removeLoading: removeLoading
};
//# sourceMappingURL=loading.js.map